var map = {
	"./skull_1.png": "b38d",
	"./skull_10.png": "f7a3",
	"./skull_10_bj.png": "8281",
	"./skull_11.png": "85b5",
	"./skull_11_bj.png": "2135",
	"./skull_12.png": "8835",
	"./skull_12_bj.png": "b5ff",
	"./skull_13.png": "81db",
	"./skull_13_bj.png": "2c54",
	"./skull_14.png": "68a2",
	"./skull_14_bj.png": "5c7f",
	"./skull_15.png": "04b9",
	"./skull_15_bj.png": "9036",
	"./skull_16.png": "d72c",
	"./skull_16_bj.png": "ff91",
	"./skull_17.png": "d588",
	"./skull_17_bj.png": "c1e3",
	"./skull_18.png": "16ab",
	"./skull_18_bj.png": "4f1d",
	"./skull_19.png": "5d48",
	"./skull_19_bj.png": "9d15",
	"./skull_1_bj.png": "0ddd",
	"./skull_2.png": "04f3",
	"./skull_20.png": "75f0",
	"./skull_20_bj.png": "23bb",
	"./skull_2_bj.png": "976c",
	"./skull_3.png": "57dc",
	"./skull_3_bj.png": "5928",
	"./skull_4.png": "93b6",
	"./skull_4_bj.png": "57bc",
	"./skull_5.png": "205d",
	"./skull_5_bj.png": "b2c2",
	"./skull_6.png": "2fe8",
	"./skull_6_bj.png": "3b7a",
	"./skull_7.png": "19fe",
	"./skull_7_bj.png": "9de9",
	"./skull_8.png": "463c",
	"./skull_8_bj.png": "fbd9",
	"./skull_9.png": "63aa",
	"./skull_9_bj.png": "38ce"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a19b";